const LOCALSTORAGE_KEY = "vs_device_id";
const IDB_DB_NAME = "vs-device";
const IDB_STORE = "ids";
const IDB_KEY = "device_id";

function generateId(): string {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getOrCreateLocalStorageId(): string | null {
  try {
    const existing = localStorage.getItem(LOCALSTORAGE_KEY);
    if (existing) return existing;
    const value = generateId();
    localStorage.setItem(LOCALSTORAGE_KEY, value);
    return value;
  } catch {
    return null;
  }
}

export function getOrCreateIndexedDbId(): Promise<string | null> {
  return new Promise((resolve) => {
    try {
      if (!window.indexedDB) {
        resolve(null);
        return;
      }
      const openRequest = indexedDB.open(IDB_DB_NAME, 1);
      openRequest.onupgradeneeded = () => {
        openRequest.result.createObjectStore(IDB_STORE);
      };
      openRequest.onerror = () => resolve(null);
      openRequest.onsuccess = () => {
        const db = openRequest.result;
        const tx = db.transaction(IDB_STORE, "readwrite");
        const store = tx.objectStore(IDB_STORE);
        const getRequest = store.get(IDB_KEY);
        getRequest.onsuccess = () => {
          const existing = getRequest.result as string | undefined;
          if (existing) {
            resolve(existing);
            db.close();
            return;
          }
          const value = generateId();
          const putRequest = store.put(value, IDB_KEY);
          putRequest.onsuccess = () => {
            resolve(value);
            db.close();
          };
          putRequest.onerror = () => {
            resolve(null);
            db.close();
          };
        };
        getRequest.onerror = () => {
          resolve(null);
          db.close();
        };
      };
      setTimeout(() => resolve(null), 1000);
    } catch {
      resolve(null);
    }
  });
}
